// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__K1E2j","fullscreen":"Spinner_fullscreen__FndDh"};